import React, { useEffect, useState } from 'react';
import { Alert, Row, Col, Button, Input, Label, FormGroup } from 'reactstrap';

import { modifyHash, yessy } from '../base/utils/miscutils';
import { getStatus } from '../base/data/DataClass';
import Advert, { KAdFormat } from '../base/data/Advert';
import DataStore from '../base/plumbing/DataStore';
import KStatus from '../base/data/KStatus';

import { Card } from '../base/components/CardAccordion';
import PropControl from "../base/components/PropControl";
import GoodLoopUnit from '../base/components/GoodLoopUnit';



function AdPreviewCard ({ advert, adid, path, skipToEndCard, Editor, iframeCallback, advanced, ...stuff }) {
	// Set a key on the adunit that we can arbitrarily change to break identity and provoke a reload
	const [unitKey, setUnitKey] = useState('');
	// Allow skip-to-endcard on the Advanced screen for easier CSS editing
	const [endcard, setEndcard] = useState(skipToEndCard);
	// Allow instant donation unlock on the Advanced screen for easier CSS editing
	const [forcedDonationUnlocked, setForcedDonationUnlocked] = useState(false);

	const [noCharityDebug, setNoCharityDebug] = useState(false);

	// if user wants to preview an ad without a charity, show them they're doing this on each page load to avoid people forgetting their in a "debug" mode
	let pageChangeHook = useEffect(() => {
		if (noCharityDebug) {
			charityCount = 0;
			setNoCharityDebug(false);
		}
	}, [DataStore.getUrlValue("workflow")]);

	Advert.assIsa(advert);
	// HACK - make sure we have a format
	if ( ! advert.format) advert.format = KAdFormat.video;
	// paths into ad bits
	const cssPath = [...path, 'advanced', 'customcss'];
	const widgetPath = ['widget', 'preview', adid];

	// TODO the new TADG display adunits
	const isDisplay = KAdFormat.display === advert.format;

	// Social ads are always displayed in portrait orientation
	const isSocial = KAdFormat.social === advert.format;
	const size = isSocial ? 'portrait' : (
		DataStore.getValue([...widgetPath, 'previewFormat']) || 'landscape'
	);
	const isPortrait = size === 'portrait';

	// same options path as on the "publish" workflow step
	const optPath = [...widgetPath, 'optionParams'];
	const optionParams = DataStore.getValue(optPath) || {};

	// Social always shows in portrait + should have "no video?" control
	const formatPicker = isSocial ? <>
		Previewing post-engagement screen for social ad.
	</> : (
		<PropControl type="select" prop="previewFormat" path={widgetPath} label="Preview format"
			labels={['Landscape', 'Portrait']} options={['landscape', 'portrait']}
			dflt="landscape"
		/>
	);
	// TODO have other sizes for display here??
	
	// Extra gl.* parameters for the ad unit - including "force social landing-page layout" for social ad
	const extraParams = { ...optionParams };
	extraParams['gl.forcedDonationUnlocked'] = forcedDonationUnlocked;
	if (isSocial) extraParams['gl.unitType'] = 'social';

	// Override default landscape container proportions?
	const unitSizeClass = (isPortrait || isSocial) ? 'portrait-size' : '';
	const cardSizeClass = (isPortrait || isSocial) ? 'portrait-preview' : '';

	let charityCount = Advert.charityList(advert).length;

	// user wants to test an ad with no charity set
	if (noCharityDebug && charityCount === 0) {
		charityCount = 1;
	}

	return (
		<Card title="Preview" {...stuff} className={`preview-card ${cardSizeClass}`}>
			<Row>
				<Col md="9">
					{/* TODO edit GoodLoopUnit to handle display ads too?? */}
					{charityCount > 0 ? (
						<GoodLoopUnit debug vertId={adid} status="DRAFT" css={DataStore.getValue(cssPath)}
							endCard={endcard} noab={!DataStore.getValue([...widgetPath, 'yesab'])}
							play="onclick" size={size} className={unitSizeClass}
							extraParams={extraParams}
							key={unitKey}
							advert={advert}
							Editor={Editor}
							iframeCallback={iframeCallback}
						/>
					) : (
						<Alert color="danger">Not ready to render a preview: No charity info. Please refer to the checklist.<br />
							<Button
								onClick={() => {
									setNoCharityDebug(true);
								}}
								className="btn bg-danger">View test ad without charity set</Button></Alert>
					)}
				</Col>
				<Col md="3">
					{formatPicker}
					{yessy(advert.ab) ? <PropControl label="A/B experiments in preview" type="checkbox" path={widgetPath} prop="yesab" help="This advert has an A/B experiment setup. By default, these previews don't randomly show the 'B' variant." /> : null}
					<PropControl label="Mobile assets" type="checkbox" path={optPath} prop="gl.forceMobile" help="Preview the mobile video" />
					<FormGroup check>
					{advanced && !isDisplay && (
						<Label check>
							<Input type="checkbox" checked={endcard} onChange={(e) => setEndcard(e.target.checked)} />Show end card
						</Label>
					)}
						<Label check>
							<Input type="checkbox" checked={forcedDonationUnlocked} onChange={(e) => setForcedDonationUnlocked(e.target.checked)} />Show Donation Unlocked
						</Label>
					</FormGroup>
					<Button onClick={() => setUnitKey(btoa(Math.random()))}>Reload</Button> to see latest changes.
					{charityCount > 1 ? <Alert color="warning">Make sure to check the unit's appearance after selecting a charity.</Alert> : null}
				</Col>
			</Row>
			{getStatus(advert) !== KStatus.PUBLISHED && <div>
				This is a preview showing your current edits. <a href={modifyHash(null, { workflow: 5 }, true)}>(Publish)</a> to make your changes live.
			</div>}
			{noCharityDebug && <Button className="btn btn-danger" onClick={() => { charityCount = 0; setNoCharityDebug(false); }}>Hide test ad without charity set</Button>}
		</Card>
	);
};

export default AdPreviewCard;
